export interface Category {
  name: string;
  slug: string;
  url: string;
  imageSeq: string;
  size: 'wide' | 'tall' | 'square' | 'large';
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageSeq: 'cat-shoes-01',
    size: 'wide',
  },
  {
    name: 'Hoodies/Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    imageSeq: 'cat-hoodies-02',
    size: 'tall',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    imageSeq: 'cat-tshirts-03',
    size: 'square',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    imageSeq: 'cat-jackets-04',
    size: 'square',
  },
  {
    name: 'Pants/Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    imageSeq: 'cat-pants-05',
    size: 'wide',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    imageSeq: 'cat-headwear-06',
    size: 'square',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    imageSeq: 'cat-sets-07',
    size: 'tall',
  },
  {
    name: 'Underwear',
    slug: 'underwear',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    imageSeq: 'cat-underwear-08',
    size: 'square',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    imageSeq: 'cat-jersey-09',
    size: 'wide',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    imageSeq: 'cat-accessories-10',
    size: 'square',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    imageSeq: 'cat-bags-11',
    size: 'tall',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    imageSeq: 'cat-belts-12',
    size: 'square',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    imageSeq: 'cat-perfumes-13',
    size: 'wide',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    imageSeq: 'cat-other-14',
    size: 'square',
  },
];